import PropTypes from 'prop-types'

const SectionTitle = ({ title }) => {
  return <h2 className="visitor-details__section-header">{title}</h2>
}

SectionTitle.propTypes = {
  title: PropTypes.string.isRequired,
}

export default SectionTitle
